<template>
  <div v-loading="loader">
    <div v-if="loader" style="height: 200px"></div>
    <div class="nav-bar">
      <div class="nav-bar__tabs tabs">
        <div class="tabs__item--recent">
          Recent transactions
        </div>
      </div>
      <div class="nav-bar__pages page">
        <router-link class="page__first" :to="get_first">Last</router-link>
        <router-link class="page__prev" :to="get_prev">&lt;</router-link>
        <span
          class="page__current"><b>{{$route.params.num !== undefined ? $route.params.num : 1}}</b> of {{max_page}}</span>
        <router-link class="page__next" :to="get_next">&gt;</router-link>
        <router-link class="page__last" :to="get_last">Last</router-link>
      </div>
      <div class="nav-bar__form-search">
        <input v-model="search_txt" name="search-token" placeholder="Search" type="search">
        <button>
          <img :src="search" alt="Search">
        </button>
      </div>
    </div>
    <div class="table-transactions">
      <div class="table-transactions__header trans">
        <div class="trans__timestamp">
          Timestamp
        </div>
        <div class="trans__addresses--recent">
          Tx Id /
          <br> Sender /
          <br> Recipient
        </div>
        <div class="trans__txid">
          Tx Id
        </div>
        <div class="trans__sender">
          Sender
        </div>
        <div class="trans__recipient">
          Recipient
        </div>
        <div class="trans__amount-fee">
          Amount /
          <br>
          <span class="grey">XEM Fee</span>
        </div>
        <div class="trans__amount">
          Amount
        </div>
        <div class="trans__fee">
          XEM Fee
        </div>
      </div>
      <div class="table-transactions__item trans" v-for="table in data_table">
        <div class="trans__timestamp">
          <div class="trans__timestamp-name">
            Timestamp
          </div>
          <div class="trans__timestamp-value">
            {{table.timeStamp}}
          </div>
        </div>
        <div class="trans__addresses--recent">
          <div>
            <router-link :to="'/tx/' + table.hash">{{table.hash}}</router-link>
          </div>
          <div>
            <router-link :to="'/address/' + table.sender + '/tx/1'">{{table.sender}}</router-link>
          </div>
          <div>
            <router-link :to="'/address/' + table.recipient + '/tx/1'">{{table.recipient}}</router-link>
          </div>
        </div>
        <div class="trans__txid--recent">
          <div class="trans__txid-name">
            Tx Id
          </div>
          <div class="trans__txid-value--recent">
            <router-link :to="'/tx/' + table.hash">{{table.hash}}</router-link>
          </div>
        </div>
        <div class="trans__sender--recent">
          <div class="trans__sender-name">
            Sender
          </div>
          <div class="trans__sender-value--recent">
            <router-link :to="'/address/' + table.sender + '/tx/1'">{{table.sender}}</router-link>
          </div>
        </div>
        <div class="trans__recipient--recent">
          <div class="trans__recipient-name">
            Recipient
          </div>
          <div class="trans__recipient-value--recent">
            <router-link :to="'/address/' + table.recipient + '/tx/1'">{{table.recipient}}</router-link>
          </div>
        </div>
        <div class="trans__amount-fee">
          <p>{{divisibility(table.quantity, table.div)}}</p>
          <p class="grey"> {{divisibility(table.fee) }}</p>
        </div>
        <div class="trans__amount">
          <div class="trans__amount-name">
            Amount
          </div>
          <div class="trans__amount-value">
            {{divisibility(table.quantity, table.div)}}
          </div>
        </div>
        <div class="trans__fee">
          <div class="trans__fee-name">
           XEM Fee
          </div>
          <div class="trans__fee-value">
            {{divisibility(table.fee) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import { createNamespacedHelpers } from 'vuex';
  import { divisibility } from '../../utils/Math_util';
  import MosaicProxy from '../../proxies/MosaicProxy';
  import search from './../../assets/images/icon/search.svg';

  const { mapState, mapActions } = createNamespacedHelpers('core');

  export default {
    props: ['txCount'],
    name: 'TableMosaicTransactions',
    async mounted() {
      this.get_data(this.$route.params.num, true);
    },
    computed: {
      ...mapState(['detail']),
      data_table() {
          return  this.tableData.filter(data => !this.search_txt
            || data.hash.toLowerCase().includes(this.search_txt.toLowerCase())
            || data.sender.toLowerCase().includes(this.search_txt.toLowerCase())
            || data.recipient.toLowerCase().includes(this.search_txt.toLowerCase())
          )
      },
      max_page() {
        return Math.ceil(Number(this.count) / 15);
      },
      get_prev() {
        const prev = Number(this.$route.params.num) - 1;
        if (prev < 1) {
          return `/address/${this.$route.params.hash}/tx/1`;
        }
        return `/address/${this.$route.params.hash}/tx/${prev}`;
      },
      get_next() {
        const next = Number(this.$route.params.num) + 1;
        if (next > this.max_page) {
          return `/address/${this.$route.params.hash}/tx/${this.max_page}`;
        }
        return `/address/${this.$route.params.hash}/tx/${next}`;
      },
      get_last() {
        return `/address/${this.$route.params.hash}/tx/${this.max_page}`;
      },
      get_first() {
        return `/address/${this.$route.params.hash}/tx/1`;

      }
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
      async tx_route(current) {
        this.$router.push({
          name: 'tx.address.table',
          params: { num: current }
        });
        await this.get_data(current);
      },
      async get_data(page, init = false) {
        let loading = null;
        if (!init) {
          loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
          });
        }
        const mosaics_proxy = new MosaicProxy();
        this.count = await mosaics_proxy.get_mosaic_count(this.$route.params.hash);
        this.tableData = await mosaics_proxy.get_mosaic_tx(this.$route.params.hash, page !== undefined ? page : 1);
        console.log(this.tableData);
        const nemEpoch = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
        this.tableData = this.tableData.map((data) => {
          const txTimestamp = new Date(nemEpoch + (data.timeStamp * 1000));
          return {
            ...data,
            timeStamp: moment(txTimestamp)
              .format('DD.MM.YYYY, HH:mm:ss')
          };
        });
        if (!init) loading.close();
        this.loader = false;
      }
    },
    watch: {
      '$route'(to, from) {
        this.get_data(this.$route.params.num);
      }
    },
    data: () => ({
      loader: true,
      tableData: [],
      count: 0,
      divisibility: divisibility,
      search,
      search_txt: ""
    })
  };
</script>

<style scoped lang="scss">
  .footer-tx {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 60px;
  }

  .amount-tb {
    text-align: right;
    height: 70px;

    span {
      display: block;
      font-size: 12px;
      color: #ccc;
    }
  }

  .nav-bar {
    margin-top: 20px;
  }
</style>
